import {Component, Input} from '@angular/core';
import {AlertController, ModalController} from '@ionic/angular';
import {PermissionsService} from '../../services/permissions.service';
import {DeviceService} from '../../services/device.service';
import {TranslationService} from '../../translation';

@Component({
  standalone: false,
  selector: 'app-permission',
  templateUrl: './permission.page.html',
  styleUrls: ['./permission.page.scss'],
})
export class PermissionPage {
  @Input() allowBackgroundLocation = false;
  public processing = false;

  constructor(
    private permissionsService: PermissionsService,
    private deviceService: DeviceService,
    private modalController: ModalController,
    private alertController: AlertController,
    private ts: TranslationService
    ) { }

  async allow() {
    if (this.processing) {
      return;
    }
    this.processing = true;

    try {
      const osVersion = await this.deviceService.getOsVersion();
      if (osVersion === '12') {
        this.modalController.dismiss({
          'permissionGranted': true
        });
        return;
      }

      const locationServicesEnabled = await this.permissionsService.isLocationServicesEnabled();
      if (!locationServicesEnabled) {
        await this.showLocationServicesDisabledAlert();
        return;
      }

      const granted = this.allowBackgroundLocation
        ? await this.permissionsService.requestBackgroundLocationPermission()
        : await this.permissionsService.requestLocationPermission();

      if (granted) {
        this.modalController.dismiss({
          'permissionGranted': true
        });
      } else {
        await this.showLocationAccessHelpAlert();
      }
    } finally {
      this.processing = false;
    }
  }

  dismiss() {
    this.modalController.dismiss({
      'permissionGranted': false
    });
  }

  private async showLocationServicesDisabledAlert() {
    await this.showLocationAccessHelpAlert();
  }

  private async showLocationAccessHelpAlert() {
    const alert = await this.alertController.create({
      header: this.ts.instant('Location Services Disabled'),
      message: this.ts.instant('Please make sure geolocation is enabled on your device and location permission is granted for this app.'),
      buttons: [this.ts.instant('OK')]
    });
    await alert.present();
  }
}
